import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {Person} from '../model/person';
import {TourService} from '../services/tour.service';

declare function require(moduleName: string): any;
const { version: appVersion } = require('../../../package.json');
// this loads package.json
// then you destructure that object and take out the 'version' property from it
// and finally with ': appVersion' you rename it to const appVersion

// <a href="mailto:gotourplayer@avidratings.com?subject=GoTour%20Web%20Player%20Feedback">Email us</a></div>

@Component({
  selector: 'gt-footer',
  template:
      `<div class="footer-container">
        <div class="page-footer">
          <div class="text-wrapper">
            <div class="email">Questions or Feedback?
              <a (click)="openDialog()" style="cursor: pointer">Contact us</a></div>
            <div class="copyright">Copyright &copy; 2017 Avid Ratings, Inc. v{{appVersion}}</div>
          </div>
         <img src="../../assets/avid-logo-black-text.png" class="avid-logo"/>
        </div>
      </div>`,

  styles: [
    `.footer-container {
      content: "";
      display: table;
      clear: both;
      width: 100%;
    }
    .page-footer {
      margin: 20px;
      margin-bottom: 25px;
      padding-top: 5px;
      border-top: 1px solid #ccc;
      font-family: Open Sans, Helvetica Neue, sans-serif !important;
      font-weight: 400;
      font-size: 1rem;
      text-align: center;
      color: #949799;
    }
    .text-wrapper {
      float: right;
    }
    .email, .copyright {
      text-align: right;
    }
    .avid-logo {
      float: left;
      height: 2.5rem;
      margin-top: 5px;
    }
    @media (min-width: 765px) {

      .page-footer {
        margin: 40px;
        margin-bottom: 50px;
        padding-top: 10px;
        font-size: 1.5rem;
      }

      .avid-logo {
        height: 4rem;
      }
    }`,
    'styles.css']
})


export class FooterComponent implements OnInit {
  public appVersion;

  constructor(public dialog: MatDialog, public tourService: TourService) {
    this.appVersion = appVersion;
  }

  ngOnInit() {
  }

  openDialog(): void {

    let dialogData = {};
    if (this.tourService.tour != null) {
      const persons: Person[] = [];
      if (this.tourService.tour.contactInfo != null) {
        for (const section of this.tourService.tour.contactInfo.sections) {
          for (const person of section.items) {
            if (person.email != null) {
              persons.push(person);
            }
          }
        }
      }
      dialogData = {builderName: this.tourService.tour.modelInfo.builder, persons: persons};
    }

    const dialogRef = this.dialog.open(FeedbackDialogComponent, {
      width: '80%',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      // this.animal = result;
    });
  }
}

@Component({
  selector: 'gt-dialog-overview-example-dialog',
  template:
    `<div class="content">
      <button class="material-icons close-button" mat-dialog-close tabindex="-1">close</button>
      <div class="view-title">What can we help you with?</div>
      <hr/>
      <div class="section">
        <div class="help-section-title"><i class="fa toolbar-icon fa-home"></i>  Model and Community Info</div>
        <p style="margin-bottom:10px">If you would like information about a specific model or community, please <b>contact
           {{builderName}} directly</b>.</p>
        <div *ngFor="let person of persons">
          <a href="mailto:{{person.email.address}}?subject=GoTour%20Inquiry" tabindex="-1" class="contact-email">
            {{person.email.displayName}}</a>
        </div>
      </div>
      <hr/>
      <div class="section">
        <div class="help-section-title">
          <i class="material-icons toolbar-icon" style="vertical-align: middle">ondemand_video</i>
          Player Feedback</div>
        <p>The GoTour player is a product of Avid Ratings. If you have feedback on the player experience please
          <a href="mailto:gotourplayer@avidratings.com?subject=GoTour%20Web%20Player%20Feedback" tabindex="-1">let us know</a>!
        </p>
      </div>
      <hr/>
      <div class="section" style="text-align:center;font-weight:bold">Thank you!</div>
    </div>`,
  styles: [
    `.close-button {
      position: relative;
      float: right;
      background-color: #E1E1E1;
    }
    .view-title {
      font-family: Open Sans Regular, Helvetica Neue, sans-serif;
      font-weight: 400;
      font-size: 2.0rem;
      line-height: 1.2;
      letter-spacing: -.1rem;
      text-transform: uppercase;
    }
    .help-section-title {
      font-weight: 700;
      font-size: 1.5rem;
      color: #e18c28;
      vertical-align: middle;
    }
    .section {
      font-size: 1.25rem;
    }
    .toolbar-icon {
      font-size: 2.5rem;
    }
    .contact-email {
      margin-left: 20px;
    }
    .mat-button {
      background-color: #E1E1E1;
    }
    hr {
      margin-top: 2rem;
      margin-bottom: 1rem;
    }
    @media (min-width: 765px) {
      .view-title {
        font-size: 2.25rem;
      }
      .help-section-title {
        font-size: 2rem;
      }
      .section {
        font-size: 1.75rem;
      }
    }`]
})

export class FeedbackDialogComponent {
  public builderName = 'the builder';
  public persons: Person[];
  constructor(
    public dialogRef: MatDialogRef<FeedbackDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      if (data.builderName) {
        this.builderName = data.builderName;
      }
      if (data.persons) {
        this.persons = data.persons;
      }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/footer.component.ts